import { ContentHeading } from 'components/Typography';
import { PaymentsCard } from 'components/payments/primitives';
import { ChargesLineItem } from 'components/payments/primitives/RefundBreakdown/lineItems';

export interface PropertyChargesProps {
  penalty: Array<{
    amount: string;
    currency: string;
  }>;
}

const PropertyCharges = ({ penalty }: PropertyChargesProps) => {
  return penalty.length > 0 ? (
    <>
      <ContentHeading>Charges & penalties</ContentHeading>
      <PaymentsCard mb={8} data-hj-suppress>
        <ChargesLineItem penalty={penalty} />
      </PaymentsCard>
    </>
  ) : null;
};

export default PropertyCharges;
